import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { readStarterGroups } from "../../../api/access/accessApi";
import { useLoad } from "../../../shared/loading/useLoad";
import LoadStatus from "../../../ui/feedback/LoadStatus";
import { systemGroupName } from "../model/groupNames";
import { PermissionChips } from "./GrantChips";

/**
 * The groups every new project starts with and what each allows, as the server says them
 * (GS-5, Sol critique C8 narrowed): fixed, so shown, not changed; the web keeps no copy.
 */
export default function StarterGroups({ itemKinds }: { itemKinds: readonly string[] }) {
  const { t } = useTranslation();
  const load = useCallback((signal: AbortSignal) => readStarterGroups(signal), []);
  const { state, reload } = useLoad(load);
  if (state.status !== "loaded") return <LoadStatus state={state} loadingLabel={t("common.loading")} onRetry={reload} compact={true} />;
  return (
    <ul className="space-y-1">
      {state.value.map((group) => (
        <li key={group.system} className="flex flex-wrap items-center gap-2 text-xs">
          <span className="text-sm font-semibold">{systemGroupName(t, group.system)}</span>
          <PermissionChips grants={group.grants} itemKinds={itemKinds} />
        </li>
      ))}
    </ul>
  );
}
